import React, { HTMLAttributes } from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import AbcCircle from "components/AbcCircle";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  bold?: boolean;
  healthWatchStatus: racehorse360.HealthWatchStatus;
}

const RiskLevelCell = (props: IProps) => {
  const { bold, healthWatchStatus, ...restProps } = props;

  return (
    <TableCellWrapper {...restProps} centered bold={bold}>
      <AbcCircle healthWatchStatus={healthWatchStatus} />
    </TableCellWrapper>
  );
};

export default React.memo(RiskLevelCell);
